import { render, staticRenderFns } from "./form-richiesta-assistenza.vue?vue&type=template&id=bd022b62&scoped=true"
import script from "./form-richiesta-assistenza.vue?vue&type=script&lang=js"
export * from "./form-richiesta-assistenza.vue?vue&type=script&lang=js"
import style0 from "./form-richiesta-assistenza.vue?vue&type=style&index=0&id=bd022b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd022b62",
  null
  
)

export default component.exports